module.exports = __webpack_public_path__ + "img/chixu2.528a2055.png";